import { render, staticRenderFns } from "./EventSuggestion.vue?vue&type=template&id=2ed979d4&scoped=true&lang=pug&"
import script from "./EventSuggestion.vue?vue&type=script&lang=js&"
export * from "./EventSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./EventSuggestion.vue?vue&type=style&index=0&id=2ed979d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed979d4",
  null
  
)

export default component.exports